<template>
  <div>
    <div class="row question-row question-row-wrapped" :style="first ? { borderTop: 'none' } : {}">
      <div style="word-wrap: break-all">
        <span class="question-text" v-html="question.questionText"></span>
      </div>
      <div>
        <input type="date" v-model="answer" :id="question.id" placeholder="dd/mm/yyyy" />
      </div>
    </div>
    <div class="row error-row">
      <div
        v-if="errorMessage"
        style="margin-left: 15px; max-width: 80%"
        class="ui-message ui-message-error ui-widget ui-corner-all"
      >
        <span class="ui-message-error-icon"></span>
        <span class="ui-message-error-detail" v-html="errorMessage" />
      </div>
      <div
        v-if="warningMessage"
        style="margin-left: 15px; max-width: 80%"
        class="ui-message ui-message-warn ui-widget ui-corner-all"
      >
        <span class="ui-message-warn-icon" />
        <span class="ui-message-warn-detail" v-html="warningMessage"></span>
      </div>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import Vue from "vue";
import poster from "../mixins/poster";
import responseAdapters from "../mixins/responseAdapters";
import validator from "../mixins/validator";

export default Vue.extend({
  mixins: [poster, validator],
  inject: ["isUs", "submitUrl", "csrfHeader", "csrf"],
  props: {
    question: { required: true },
    showRequired: { required: true },
    first: { required: true },
    validate: { required: false, default: true },
    appTheme: { required: false },
    onLastQuestion: { required: false, default: false },
  },
  data() {
    return {
      answer: this.question.response,
      responseAdapter: responseAdapters.date,
      initialAnswer: null,
    };
  },
  created() {
    this.$emit("answer", this.question, this.responseAdapter(this.question));
    if (this.question.response != null) {
      this.$emit("update-next-button-status", true);
      this.hasDefaultAnswer = true;
      this.initialAnswer = this.question.response;
    }
  },
  computed: {
    showMessage() {
      if (this.answer === null) {
        return null;
      }

      return !this.isDateCorrect;
    },
    valid() {
      return typeof this.errorMessage !== "string";
    },
    warningMessage() {
      if (this.showMessage) {
        return this.question.warning;
      }

      return null;
    },
    errorMessage() {
      if (this.validate && this.showMessage) {
        return this.question.rejectReason;
      }

      if (this.showRequired && this.answer === null) {
        return "You must answer the question to continue";
      }

      return null;
    },
    isDateCorrect() {
      return (
        this.answer !== null &&
        (this.question.minDateText === null ||
          new Date(this.answer).getTime() >= new Date(this.question.minDateText).getTime())
      );
    },
  },
  watch: {
    answer(newValue) {
      if (_.isNull(this.initialAnswer)) {
        this.initialAnswer = newValue;
      }

      this.question.response = newValue;
      this.question.isChangedAnswer = this.question.isChangedAnswer || newValue !== this.initialAnswer;
      this.post(this.responseAdapter(this.question));

      if (this.isUs && !this.hasDefaultAnswer) {
        if (this.showMessage) {
          if (!this.validate) {
            this.$emit("update-next-button-status", true);
          }
        } else {
          this.$emit("next");
        }
      }
    },
  },
});
</script>
